import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/Sheetupoad.scss";
import $ from "jquery";
import { setTheSHeetuploaAction } from "../../../Redux/Slice";
import * as XLSX from "xlsx";
import Spreadsheet from "react-spreadsheet";
import { saveAs } from "file-saver";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SheetUpload = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const formdatas = new FormData();
  const [apidata, setApidata] = useState(null);
  const [key, setKey] = useState(null);
  const [ErrorKey, setErroKey] = useState(0);

  const dispatch = useDispatch();
  const options = [
    // {
    //   label: "Client Branch",
    //   value: "client_branch",
    // },
    {
      label: "Client ",
      value: "client_parent",
    },
    {
      label: "State",
      value: "state",
    },
    {
      label: "Role",
      value: "role",
    },
    {
      label: "Perform",
      value: "perform_type",
    },
    {
      label: "Perform Type",
      value: "perform_question",
    },
    {
      label: "Side bar",
      value: "side_bar",
    },
    {
      label: "Grievance type",
      value: "grievance_type",
    },
    {
      label: "Leave type",
      value: "leave_type",
    },
  ];

  const [FileType, setFileType] = useState("");
  const [fileErr, setFileErr] = useState("");
  const [file, setFile] = useState();
  const [fileemp, setFileEp] = useState("");

  const [data, setData] = useState([]);

  const handleSelectChange = (val) => {
    setFileType(val.value);
  };
  var z = 0;
  
  $("form").on("change", ".file-upload-field", function () {
    $(this)
      .parent(".file-upload-wrapper")
      .attr(
        "data-text",
        $(this)
          .val()
          .replace(/.*(\/|\\)/, "")
      );
  });
  const HandleChanegsFile = (e) => {
    if (FileType == "") {
      z = 1;
      setFileErr("*file name is required");
    }

    setFile(e.target.files[0]);
    const file = e.target.files[0];

    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setData(parsedData);
    };

    reader.readAsBinaryString(file);

    //  console.log(e.target.files[0] ,"sdfcwuca");
  };

  // Initial data
  const [datas, setDatas] = useState([
    [
      { value: "A1" },
      { value: "B1" },
      { value: "C1" },
      { value: "D1" },
      { value: "E1" },
      { value: "F1" },
      { value: "G1" },
      { value: "H1" },
    ],
    [
      { value: "A2" },
      { value: "B2" },
      { value: "C2" },
      { value: "D2" },
      { value: "E2" },
      { value: "F2" },
      { value: "G2" },
      { value: "H2" },
    ],
    [
      { value: "A3" },
      { value: "B3" },
      { value: "C3" },
      { value: "D3" },
      { value: "E3" },
      { value: "F3" },
      { value: "G3" },
      { value: "H3" },
    ],
    [
      { value: "A4" },
      { value: "B4" },
      { value: "C4" },
      { value: "D4" },
      { value: "E4" },
      { value: "F4" },
      { value: "G4" },
      { value: "H4" },
    ],
    [
      { value: "A5" },
      { value: "B5" },
      { value: "C5" },
      { value: "D5" },
      { value: "E5" },
      { value: "F5" },
      { value: "G5" },
      { value: "H5" },
    ],
    [
      { value: "A6" },
      { value: "B6" },
      { value: "C6" },
      { value: "D6" },
      { value: "E6" },
      { value: "F6" },
      { value: "G6" },
      { value: "H6" },
    ],
  ]);

  useEffect(() => {
    if (FileType == "side_bar") {
      setDatas([
        [
          { value: "display_name" },
          { value: "unique_name" },
          { value: "display_order" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "CLIENT" },
          { value: "client" },
          { value: "1" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "ROLE" },
          { value: "role" },
          { value: "2" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "KYC VERIFICATION" },
          { value: "kyc verification" },
          { value: "3" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "ATTENDANCE" },
          { value: "attendances" },
          { value: "4" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "SKILL ASSEMENTS" },
          { value: "assements" },
          { value: "5" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "client_parent") {
      setDatas([
        [
          { value: "CLNT" },
          { value: "PERAREA" },
          { value: "PROJNO" },
          // { value: "DWEB ELEMENT1" },
          // { value: "LOCATION" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "QPMS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "CODOID" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "QPMS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "QPMS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "QPMS" },
          { value: "0978" },
          { value: "UDS273648723" },
          // { value: "UDS273648723" },
          // { value: "TAMBARAN" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "state") {
      setDatas([
        [
          { value: "Per Area" },
          { value: "State" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "1100" },
          { value: "TAMIL NADU" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "1100" },
          { value: "PUDUCHERRY" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "1100" },
          { value: "KERALA" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "1100" },
          { value: "TELANGANA" },
          // { value: "C5" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "1100" },
          { value: "KARNATAKA" },
          // { value: "C6" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "role") {
      setDatas([
        [
          { value: "Position No" },
          { value: "Designation" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "50544975" },
          { value: "TECHNICAL ASSOCIATE 30" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "50544975" },
          { value: "ASST STATISTICS OFFICER" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "50544975" },
          { value: "TECHNICAL ASSOCIATE 30" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "50544975" },
          { value: "PHARMACIST GRADE  2 O" },
          // { value: "C5" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "50544975" },
          { value: "TECHNICAL ASSOCIATE 30" },
          // { value: "C6" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "leave_type") {
      setDatas([
        [
          { value: "LEAVE_TYPE" },
          { value: "DESCRIPTION" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "PERSONAL_LEAVE" },
          { value: "personal_leave" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "CASUAL_LEAVE" },
          { value: "casual_leave" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "LOSS_OF_PAY" },
          { value: "loss_of_pay" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        // [
        //   { value: "A5" },
        //   { value: "B5" },
        //   { value: "C5" },
        //   { value: "D5" },
        //   { value: "E5" },
        //   { value: "F5" },
        //   { value: "G5" },
        //   { value: "H5" },
        // ],
        // [
        //   { value: "A6" },
        //   { value: "B6" },
        //   { value: "C6" },
        //   { value: "D6" },
        //   { value: "E6" },
        //   { value: "F6" },
        //   { value: "G6" },
        //   { value: "H6" },
        // ],
      ]);
    } else if (FileType == "grievance_type") {
      setDatas([
        [
          { value: "GRIEVANCE TYPE" },
          { value: "DESCRIPTION" },
          // { value: "C1" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "UNIFORM ISSUE" },
          { value: "Uniform Issue" },
          // { value: "C2" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "SHIFT NOT ALLOCATED" },
          { value: "Shift Not Allocated" },
          // { value: "C3" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "OTHER" },
          { value: "Other" },
          // { value: "C4" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        // [
        //   { value: "A5" },
        //   { value: "B5" },
        //   { value: "C5" },
        //   { value: "D5" },
        //   { value: "E5" },
        //   { value: "F5" },
        //   { value: "G5" },
        //   { value: "H5" },
        // ],
        // [
        //   { value: "A6" },
        //   { value: "B6" },
        //   { value: "C6" },
        //   { value: "D6" },
        //   { value: "E6" },
        //   { value: "F6" },
        //   { value: "G6" },
        //   { value: "H6" },
        // ],
      ]);
    } else if (FileType == "perform_question") {
      setDatas([
        [
          { value: "manpower_grading_points" },
          { value: "total_points" },
          { value: "points" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "Grooming Standard" },
          { value: "10" },
          { value: "1" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "Knowledge of site areas" },
          { value: "5" },
          { value: "0.833" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "Knowledge of washroom cleaning" },
          { value: "10" },
          { value: "1" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "Knowledge of chemical usage" },
          { value: "10" },
          { value: "2" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "Knowledge of HK Equipments" },
          { value: "5" },
          { value: "1" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    } else if (FileType == "perform_type") {
      setDatas([
        [
          { value: "Question" },
          { value: "Perform Name" },
          // { value: "D1" },
          // { value: "E1" },
          // { value: "F1" },
          // { value: "G1" },
          // { value: "H1" },
        ],
        [
          { value: "Shaved" },
          { value: "Grooming Standard" },
          // { value: "D2" },
          // { value: "E2" },
          // { value: "F2" },
          // { value: "G2" },
          // { value: "H2" },
        ],
        [
          { value: "Shoes Polished" },
          { value: "Grooming Standard" },
          // { value: "D3" },
          // { value: "E3" },
          // { value: "F3" },
          // { value: "G3" },
          // { value: "H3" },
        ],
        [
          { value: "Wearing Complete Uniform" },
          { value: "Grooming Standard" },
          // { value: "D4" },
          // { value: "E4" },
          // { value: "F4" },
          // { value: "G4" },
          // { value: "H4" },
        ],
        [
          { value: "Uniform Cleaned" },
          { value: "Grooming Standard" },
          // { value: "D5" },
          // { value: "E5" },
          // { value: "F5" },
          // { value: "G5" },
          // { value: "H5" },
        ],
        [
          { value: "Hair Combed" },
          { value: "Grooming Standard" },
          // { value: "D6" },
          // { value: "E6" },
          // { value: "F6" },
          // { value: "G6" },
          // { value: "H6" },
        ],
      ]);
    }

    // else if (FileType == "client_branch") {
    //   setDatas([
    //     [
    //       { value: "CLIENT BRANCH" },
    //       { value: "Address" },
    //       { value: "STATE NAME" },
    //       { value: "REGION NAME" },
    //       { value: "ZONE NAME" },
    //       { value: "LATITUDE" },
    //       { value: "LONGITUDE" },
    //       // { value: "H1" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H2" },
    //     ],
    //     [
    //       { value: "CODOID" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H3" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H4" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H5" },
    //     ],
    //     [
    //       { value: "UDS" },
    //       { value: "0978" },
    //       { value: "TAMIL NADE" },
    //       { value: "CHENNAI" },
    //       { value: "TAMBARAN" },
    //       { value: "12.687" },
    //       { value: "19.657" },
    //       // { value: "H6" },
    //     ],
    //   ]);
    // }
  }, [FileType]);

  const handleDownload = () => {
    const aoaData = datas.map((row) => row.map((cell) => cell.value));
    if (datas.length === 0) {
      console.error("No data to download");
      return;
    }

    // Convert data to array of arrays (AoA) format

    // Check if aoaData is correctly created
    if (aoaData.length === 0 || aoaData[0].length === 0) {
      console.error("AoA Data is empty or incorrectly formatted:", aoaData);
      return;
    }

    // Create a new workbook and a worksheet
    const ws = XLSX.utils.aoa_to_sheet(aoaData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to a buffer
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    console.log("Excel Buffer:", new Uint8Array(excelBuffer)); // Debugging line

    // Create a Blob from the buffer and save it as an Excel file
    try {
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${FileType}.xlsx`);
      console.log("File saved successfully");
    } catch (error) {
      console.error("Error creating Blob or saving file:", error);
    }
  };

  console.log(file, "file");

  const HandleUpload = () => {
    var a = 0;
    if (FileType == "") {
      a = 1;
      setFileErr("*file name is required");
    }
    if (file == "" || file == undefined) {
      a = 1;
      setFileEp("*file is required");
    }
    if (a == 0 && ErrorKey == 0) {
      formdatas.append("file", file);
      formdatas.append("file_type", FileType);

      // console.log(FileType, "FileType", file);
      const payload = {
        formdatas: formdatas,
      };
      dispatch(setTheSHeetuploaAction(payload));
      // setFileType("");
      // setFile("");
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Sheet Upload </h3>


          </div>
        </div>

        <div className="UploadSHEET">
          <div
            className="row Filters"
            style={{ marginRight: "0px", padding: " 0px 45px" }}
          >
            <div className="col-6 mt-3" style={{zIndex:"99"}}>
              <label for="validationCustom01" class="form-label">
                Upload Options
                <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                className="Selects stateNames"
                styles={{ position: "relative", top: "60px" }}
                onChange={(e) => {
                  handleSelectChange(e);
                  setFileErr("");
                }}
                options={options}
                labelledBy="Select"
              />
              <p className="Error">{fileErr}</p>
            </div>
          </div>
          <div className="Uploadningfield" style={{ marginTop: "50px" }}>
            <div
              class="row"
              style={{
                marginRight: "0px",
                padding: " 0px 45px",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <div className="col-6">
                <form class="form">
                  <div
                    class="file-upload-wrapper"
                    data-text="Select your file!"
                  >
                    <input
                      name="file-upload-field"
                      type="file"
                      class="file-upload-field"
                      onChange={(e) => {
                        // HandleChanegsFile(e);
                        // setFileEp("");

                        const file = e.target.files[0];
                        const fileName = file.name.toLowerCase();
                        if (
                          fileName.endsWith(".xls") ||
                          fileName.endsWith(".xlsx")
                        ) {
                          // Handle the file upload
                          HandleChanegsFile(e);
                          setFileEp("");
                          setErroKey(0);
                        } else {
                          // Display an error message or handle the case where the file is not an Excel sheet

                          toast.error(
                            ` ${"Please select an Excel file (.xls or .xlsx)"} `,
                            {
                              position: toast.POSITION.TOP_RIGHT,
                            }
                          );
                          setFile();
                          // You can also clear the input field if needed
                          e.target.value = "";
                          // Optionally, perform additional actions such as resetting state or displaying an error message
                          setFileEp(
                            "*Please select an Excel file (.xls or .xlsx)"
                          );
                          setErroKey(1);
                        }
                      }}
                    />
                  </div>
                </form>
                <p className="Error">{fileemp}</p>

                <div
                  className="row"
                  style={{
                    marginRight: "0px",
                    padding: " 0px 45px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    className="col-12 mt-5"
                    style={{
                      display: "flex",
                      gap: "20px",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      class="btn  SaveBtn"
                      style={{ background: "#234492", color: "#ffff" }}
                      type="submit"
                      onClick={(e) => HandleUpload()}
                    >
                      Submit
                    </button>
                    {FileType != "" && FileType != "client_branch" ? (
                      <button
                        class="btn  SaveBtn"
                        style={{ background: "#234492", color: "#ffff" }}
                        type="submit"
                        onClick={(e) => handleDownload()}
                      >
                        Preview{" "}
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 
          <div
            className="row"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <div className="col-12 mt-5">
              <MySpreadsheet FileType={FileType} />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default SheetUpload;
